var React = require('react');

function InfoLight (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"12","cy":"11.5","rx":"9","ry":"8.625","stroke":"#2747AB","key":0}),React.createElement("path",{"d":"M12.5 7.18742C12.5 7.45205 12.2761 7.66658 12 7.66658C11.7239 7.66658 11.5 7.45205 11.5 7.18742C11.5 6.92278 11.7239 6.70825 12 6.70825C12.2761 6.70825 12.5 6.92278 12.5 7.18742Z","fill":"#2747AB","key":1}),React.createElement("path",{"d":"M12 16.2916V9.58325","stroke":"#2747AB","key":2})]);
}

InfoLight.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23","fill":"none"};

module.exports = InfoLight;

InfoLight.default = InfoLight;
